import * as styledComponents from "styled-components";
import { ThemedStyledComponentsModule } from "styled-components";

import theme from "./theme";

type Theme = typeof theme;
export type ThemeProp = { theme: Theme };

const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
} = styledComponents as unknown as ThemedStyledComponentsModule<Theme>;

export { createGlobalStyle, css, keyframes, styled, ThemeProvider };
export default styled;
